import React from 'react'
import PropTypes from 'prop-types'
import { t } from '@lingui/macro'
import LocalisedImage from '../LocalisedImage'

import './StickyNote.scss'


const Image = ({ imgSrc, ...props }) => (
  <div className="sticky-note__image">
    <LocalisedImage src={imgSrc} {...props} alt={t`About Yoti`} />
  </div>
)

Image.propTypes = {
  imgSrc: PropTypes.string.isRequired,
}

const StickyNote = ({
  icon, children, bgColor
}) => {
  const style = {
    ...(bgColor ? { background: bgColor } : {})
  }

  return (
    <div className="sticky-note" style={style}>
      {
        icon
        && (
          <div className="sticky-note__icon-column">
            <span className="sticky-note__icon-column__icon">{icon}</span>
          </div>
        )
      }
      <div className="sticky-note__main-column">
        { children }
      </div>
    </div>
  )
}

StickyNote.propTypes = {
  icon: PropTypes.element,
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired,
}

StickyNote.defaultProps = {
  icon: null,
  bgColor: null
}

export default StickyNote
